module.exports = __webpack_public_path__ + "img/hb_img03.8b58e4de.png";